// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-toast-container {
  top: 20px !important;
  right: 24px !important;
}
.custom-toast-container .toast {
  pointer-events: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/Toast/toast-container.scss"],"names":[],"mappings":"AACA;EACE,oBAAA;EACA,sBAAA;AAAF;AAEE;EACE,oBAAA;AAAJ","sourcesContent":["// Custom styles for React Bootstrap ToastContainer\n.custom-toast-container {\n  top: 20px !important;\n  right: 24px !important;\n\n  .toast {\n    pointer-events: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
